import request from '@/utils/request'


// 查询电子集卡盖章记录列表
export function listDianziJika(query) {
  return request({
    url: '/zb/dianzi/jika/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询电子集卡盖章记录分页
export function pageDianziJika(query) {
  return request({
    url: '/zb/dianzi/jika/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询电子集卡盖章记录详细
export function getDianziJika(data) {
  return request({
    url: '/zb/dianzi/jika/detail',
    method: 'get',
    params: data
  })
}

// 新增电子集卡盖章记录
export function addDianziJika(data) {
  return request({
    url: '/zb/dianzi/jika/add',
    method: 'post',
    data: data
  })
}

// 修改电子集卡盖章记录
export function updateDianziJika(data) {
  return request({
    url: '/zb/dianzi/jika/edit',
    method: 'post',
    data: data
  })
}

// 删除电子集卡盖章记录
export function delDianziJika(data) {
  return request({
    url: '/zb/dianzi/jika/delete',
    method: 'post',
    data: data
  })
}
